import { Component, Input, OnInit } from '@angular/core';
import { Router} from '@angular/router';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {WidgetListComponent} from '../../../@core/component/add-widget/modal/widget.list.component';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {



  @Input() position = 'normal';

  user: any;

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private userService: UserService,
              private analyticsService: AnalyticsService,
              private router: Router,
              private modalService: NgbModal
              ) {
  }

  ngOnInit() {
    this.userService.getUsers()
      .subscribe((users: any) => this.user = users.nick);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');
    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  logout() {
      this.router.navigateByUrl('/auth/logout');
  }

  onAddWidget() {

      this.modalService.open(WidgetListComponent, {
          size: 'lg',
          backdrop: 'static',
          container: 'nb-layout',
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/@theme/components/header/header.component.ts